export default __webpack_public_path__ + "sort-arrows-couple-pointing-up-and-down.png";